import { render, staticRenderFns } from "./UpdatePeriodDialog.vue?vue&type=template&id=b82c28f2&"
import script from "./UpdatePeriodDialog.vue?vue&type=script&lang=js&"
export * from "./UpdatePeriodDialog.vue?vue&type=script&lang=js&"
import style0 from "./UpdatePeriodDialog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports